export default __webpack_public_path__ + "static/media/ic_myc_custom.88019a85.svg";